import { JetView } from 'webix-jet';
import { devConfig, profile } from '../../../config/config';

/**
 * Class representing the FilterReprintCheckView.
 * @extends JetView
 */
export default class FilterReprintCheckView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Date picker input
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for check number
                            name: 'NroCheck',
                            minWidth: 200,
                            label: _('Nro Cheque:'),
                            labelPosition: 'top',
                            placeholder: _('Nro Cheque'),
                        },
                        {
                            view: 'text', // Text input for client name
                            name: 'Client',
                            minWidth: 200,
                            label: _('Cliente:'),
                            labelPosition: 'top',
                            placeholder: _('Cliente'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for origin selection
                            name: 'Origin',
                            minWidth: 200,
                            label: _('Origen'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '0', value: _('Nota Retiro') },
                                { id: '1', value: _('Ticket') },
                            ],
                        },
                        {
                            view: 'text', // Text input for reference document
                            name: 'ReferenceDocument',
                            minWidth: 200,
                            label: _('Documento Referente:'),
                            labelPosition: 'top',
                            placeholder: _('Documento Referente'),
                        },
                        {
                            view: 'text', // Text input for client document
                            name: 'DocClient',
                            minWidth: 200,
                            label: _('Doc. Cliente:'),
                            labelPosition: 'top',
                            placeholder: _('Doc. Cliente'),
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: 100,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: 110,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('reprintCheck:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            margin: 10,
            cols: [
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            view: 'button', // Clear button for second form
                            value: _('Limpiar'),
                            width: 100,
                            click: () => {
                                $$('myForm2').clear(); // Clears the second form
                            },
                        },
                        {
                            view: 'button', // Consult button for second form
                            value: _('Consultar'),
                            type: 'form',
                            width: 110,
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get values from second form
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('reprintCheck:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2], // Upper section with second set of buttons
        };
        const filterPopup = webix.ui({
            view: 'window', // Popup window for filters
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3],
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm', // Main form for filters
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const lang = this.app.getService('locale').getLang(); // Get current language
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional setup for small screens can be added here
            }
            $$('Datepicker').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang); // Set date modal configuration
            });
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
